import React, { useEffect, useState } from 'react';
import http from '../services/http';
import { endPoints } from '../utils/constanst';

const useOcupacion = ({ loading }) => {

    const [ocupacions, setOcupacion] = useState([]);

    const getOcupacion = async () => { 
        
        const data = await http(`${endPoints.catalog}ocupacion`).get();

        setOcupacion(data);

    };

    useEffect(() => {

        if(!loading)
            getOcupacion();

    }, [loading]);


    return {        
        ocupacions,
        setOcupacion,
        getOcupacion
    }
}

export default useOcupacion;
